module.exports = __webpack_public_path__ + "static/img/2.61e30e11.jpg";